const KILO_FACTOR = 1000;

const toNumber = (value: string | null | undefined): number | null => {
  if (!value) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const formatScaledNumber = (value: number): string => {
  const fixed = value.toFixed(12);
  return fixed.replace(/\.?0+$/, "");
};

const scale = (
  value: string | null | undefined,
  factor: number,
  operation: "multiply" | "divide",
): string | null => {
  if (value === null || value === undefined || value === "") return null;
  const numeric = toNumber(value);
  if (numeric === null) return value;
  const scaled = operation === "multiply" ? numeric * factor : numeric / factor;
  return formatScaledNumber(scaled);
};

export const mwhToKwh = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "multiply");

export const kwhToMwh = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "divide");

export const mwToKw = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "multiply");

export const kwToMw = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "divide");

export const plnPerMwhToPlnPerKwh = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "divide");

export const plnPerKwhToPlnPerMwh = (value: string | null | undefined): string | null =>
  scale(value, KILO_FACTOR, "multiply");
